import React, { useEffect, useState } from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Button, Card, CardContent, Fab, Grid2, LinearProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import PraDaftar from '../components/Daftar/PraDaftar';
import Perhatian from '../components/Daftar/Perhatian';
import DataSantri from '../components/Daftar/DataSantri';
import SekolahAsal from '../components/Daftar/SekolahAsal';
import DataAyah from '../components/Daftar/DataAyah';
import DataIbu from '../components/Daftar/DataIbu';
import DataLain from '../components/Daftar/DataLain';
import DataWali from '../components/Daftar/DataWali';
import DataPrestasi from '../components/Daftar/DataPrestasi';
import DataKesehatan from '../components/Daftar/DataKesehatan';
import { NavigateBefore, WhatsApp } from '@mui/icons-material';
import DataTujuan from './../components/Daftar/DataTujuan';
import { Commons } from '../helper/CommonService';
import { API_HOST, CONFIG_PENDAFTARAN, CONTACT_WA, JENJANG_TUJUAN, KELAS_TUJUAN, PENANGGUNG_JAWAB_BIAYA } from '../helper/Constant';
import LoadingButton from '@mui/lab/LoadingButton';
import ShowNotif from '../components/general/ShowNotif';



function Daftar() {
    const navigate = useNavigate(); // Initialize the navigate function
    const [waParam, setWaParam] = useState();
    const { tingkat } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [showNotif, setShowNotif] = useState(false);
    const [notifData, setNotifData] = useState({});
    const [step, setStep] = useState(0);
    const [dataSantri, setDataSantri] = useState(null);
    const [dataPerhatian, setDataPerhatian] = useState(null);
    const [dataJenjang, setDataJenjang] = useState(null);
    const [dataSekolahAsal, setDataSekolahAsal] = useState(null);
    const [dataAyah, setDataAyah] = useState(null);
    const [dataIbu, setDataIbu] = useState(null);
    const [dataWali, setDataWali] = useState(null);
    const [dataLain, setDataLain] = useState(null);
    const [dataPrestasi, setDataPrestasi] = useState(null);
    const [dataKesehatan, setDataKesehatan] = useState(null);
    const [isAbleToNext, setIsAbleToNext] = useState(false);

    const ChangePraDaftar = (propertyName, propertyValue) => {
        if (propertyName === "jenjang_tujuan") {
            setDataJenjang(prev => ({
                ...prev,
                [propertyName]: propertyValue
            }));
        } else {
            setDataSantri(prev => ({
                ...prev,
                [propertyName]: propertyValue
            }));
        }
    }

    const ChangeDataSantri = (propertyName, propertyValue) => {
        setDataSantri(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataAyah = (propertyName, propertyValue) => {
        setDataAyah(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataIbu = (propertyName, propertyValue) => {
        setDataIbu(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataWali = (propertyName, propertyValue) => {
        setDataWali(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataLain = (propertyName, propertyValue) => {
        setDataLain(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataPrestasi = (propertyName, propertyValue) => {
        setDataPrestasi(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataKesehatan = (propertyName, propertyValue) => {
        setDataKesehatan(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataPerhatian = (propertyName, propertyValue) => {
        setDataPerhatian(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataSekolahAsal = (propertyName, propertyValue) => {
        setDataSekolahAsal(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataTujuan = (propertyName, propertyValue) => {
        setDataJenjang(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const IsPraDaftarValid = () => {
        let valid = true;
        const requiredFields = document.querySelectorAll('input[required],select[required],checkbox[required],[data-required]');
        for (const field of requiredFields) {
            if (field.type === 'checkbox' && !field.checked) {
                return false;
            }
            else if (field.role === 'radiogroup' && field.attributes["data-required"]?.value) {
                const nameField = field.attributes["data-radioname"]?.value;
                const selectedRadio = document.querySelector('input[name="' + nameField + '"]:checked');
                if (!selectedRadio) {
                    return false;
                }
            }
            else if (!field.value) {
                return false;
            }
        }
        return valid
    }

    const RenderCardForm = (step) => {
        if (step === 0) {
            return (
                <PraDaftar dataJenjang={dataJenjang} dataSantri={dataSantri} handleChange={ChangePraDaftar}></PraDaftar>
            )
        } else if (step === 1) {
            return (
                <Perhatian data={dataPerhatian} handleChange={ChangeDataPerhatian}></Perhatian>
            )
        } else if (step === 2) {
            return (
                <DataSantri data={dataSantri} handleChange={ChangeDataSantri}></DataSantri>
            )
        } else if (step === 3) {
            return (
                <DataTujuan data={dataJenjang} handleChange={ChangeDataTujuan}></DataTujuan>
            )
        } else if (step === 4) {
            return (
                <SekolahAsal data={dataSekolahAsal} handleChange={ChangeDataSekolahAsal}></SekolahAsal>
            )
        } else if (step === 5) {
            return (
                <DataLain data={dataLain} handleChange={ChangeDataLain}></DataLain>
            )
        } else if (step === 6) {
            return (
                <DataAyah isPenanggungJawab={dataLain?.no_wa === CONTACT_WA.AYAH} data={dataAyah} handleChange={ChangeDataAyah}></DataAyah>
            )
        } else if (step === 7) {
            return (
                <DataIbu isPenanggungJawab={dataLain?.no_wa === CONTACT_WA.IBU} data={dataIbu} handleChange={ChangeDataIbu}></DataIbu>
            )
        } else if (step === 8) {
            return (
                <DataWali isPenanggungJawab={dataLain?.no_wa === CONTACT_WA.WALI} data={dataWali} handleChange={ChangeDataWali}></DataWali>
            )
        } else if (step === 9) {
            return (
                <DataPrestasi data={dataPrestasi} handleChange={ChangeDataPrestasi}></DataPrestasi>
            )
        } else if (step === 10) {
            return (
                <DataKesehatan data={dataKesehatan} handleChange={ChangeDataKesehatan}></DataKesehatan>
            )
        }
        return (
            <></>
        )
    }

    const PrevStep = () => {
        if (step === 5 && dataJenjang && ((dataJenjang.jenjang_tujuan === JENJANG_TUJUAN.PAUDLQ) || (dataJenjang.jenjang_tujuan === JENJANG_TUJUAN.PAUDQ) || (dataJenjang.jenjang_tujuan === JENJANG_TUJUAN.TKQ) || (dataJenjang.jenjang_tujuan === JENJANG_TUJUAN.SD && dataJenjang.kelas_tujuan === KELAS_TUJUAN["SD"][0]))) {
            setStep(prevStep => prevStep - 2);
            return;
        }
        if (step === 9 && dataLain && dataLain.penanggung_jawab_biaya === PENANGGUNG_JAWAB_BIAYA.ORANG_TUA) {
            setStep(prevStep => prevStep - 2);
            return;
        }
        setStep(prevStep => prevStep - 1);
    }

    const NextStep = () => {
        if (step === 3 && dataJenjang && ((dataJenjang.jenjang_tujuan === JENJANG_TUJUAN.PAUDLQ) || (dataJenjang.jenjang_tujuan === JENJANG_TUJUAN.PAUDQ) || (dataJenjang.jenjang_tujuan === JENJANG_TUJUAN.TKQ) || (dataJenjang.jenjang_tujuan === JENJANG_TUJUAN.SD && dataJenjang.kelas_tujuan === KELAS_TUJUAN["SD"][0]))) {
            setStep(prevStep => prevStep + 2);
            return;
        }
        if (step === 7 && dataLain && dataLain.penanggung_jawab_biaya === PENANGGUNG_JAWAB_BIAYA.ORANG_TUA) {
            setStep(prevStep => prevStep + 2);
            return;
        }
        if (step === 10) {
            setIsLoading(true);
            var data = {
                "data_santris": dataSantri,
                "data_sekolahs": dataSekolahAsal,
                "data_tujuans": dataJenjang,
                "data_ayahs": dataAyah,
                "data_ibus": dataIbu,
                "data_lains": dataLain,
                "data_walis": dataWali,
                "data_prestasis": dataPrestasi,
                "data_kesehatans": dataKesehatan
            }
            var valiDatedData = Commons.ValidateDataSubmit(data);
            Commons.PostData(API_HOST + "/registeruser", valiDatedData)
                .then((successResponse) => {
                    console.log(successResponse);
                    if (!successResponse || !successResponse["user"] || !successResponse["user"]["id"]) {
                        throw new Error("The Response format doesnt correct");
                    }
                    let newStorageData = { "id": successResponse["user"]["id"], "tahun_ajaran": successResponse["user"]["tahun_ajaran"] };
                    Commons.SaveInStorage(newStorageData);
                    setNotifData({
                        "status": "success",
                        "message": "Daftar data Santri berhasil"
                    });
                    navigate('/main');
                })
                .catch(async (failResponse) => {
                    const errorData = await failResponse;
                    setNotifData({
                        "status": "error",
                        "message": "Daftar data Santri Gagal, dengan error: " + errorData.message
                    });
                    console.log(errorData);
                })
                .finally(() => {
                    setShowNotif(true);
                    setIsLoading(false);
                });
            return;
        }
        setStep(prevStep => prevStep + 1);
    }

    useEffect(() => {
        if (!waParam) {
            Commons.GetAdditionalInformation(CONFIG_PENDAFTARAN.WA_CONTACT_US)
                .then((response) => {
                    setWaParam(response);
                });
        }
    }, []);

    useEffect(() => {
        let checkValid = IsPraDaftarValid();
        setIsAbleToNext(checkValid);
    }, [step, dataSantri, dataPerhatian, dataJenjang, dataAyah, dataIbu, dataWali, dataSekolahAsal, dataKesehatan, dataLain, dataPrestasi]);

    return (
        <>
            <ShowNotif isShow={showNotif} data={notifData} actionClose={() => { setShowNotif(false); }}></ShowNotif>
            {RenderCardForm(step)}
            <Card sx={{ mt: 5 }}>
                <CardContent>
                    <LinearProgress variant="determinate" value={(step / 10) * 100} />
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                        {
                            (step !== 0) ?
                                (<Button sx={{ marginRight: "20px", backgroundColor: '#e96726' }} variant='contained' onClick={() => { PrevStep(); }} startIcon={<NavigateBefore></NavigateBefore>}>Sebelumnya</Button>)
                                : null
                        }

                        <LoadingButton
                            sx={{ backgroundColor: '#e96726' }}
                            disabled={!isAbleToNext}
                            endIcon={<NavigateNextIcon></NavigateNextIcon>}
                            loadingPosition="end" variant="contained"
                            loading={isLoading}
                            onClick={NextStep}>
                            {isLoading ? "Processing" : (step === 10) ? "Simpan" : "Selanjutnya"}
                        </LoadingButton>
                    </div>
                </CardContent>
            </Card>
            <Fab target='_blank' href={'https://wa.me/' + waParam} sx={{ position: "fixed", bottom: 16, right: 16 }} color='success' size='large'>
                <WhatsApp></WhatsApp>
            </Fab>
        </>
    );
}
export default Daftar;
